import pubSub from '../utils/pubSub';
import { dom } from '../utils/dom';

const p = val => {
  return val / 100;
};

class CalcModel {
  constructor() {
    // @NOTE doesn't do much - just for initial slider value
    this.vars = {
      hoursPerWeek: 0
    };

    window.DOM = dom;

    pubSub.trigger('var:set', {
      name: 'hoursPerWeek',
      val: this.vars.hoursPerWeek
    });

    pubSub.on('forms:performCalc', this.doCalculations.bind(this));
    // this.onVarChanged = this.onVarChanged.bind(this);
    pubSub.on('var:changed', this.onVarChanged);
    // pubSub.on('resetModel', this.init.bind(this));
    // this.init();
  }

  doCalculations() {
    //   alert('calcs');

    let vars = {
      rate: parseFloat(dom.els.theHourlyRate.value),
      hours: window.$hours, // parseFloat(this.vars.hoursPerWeek),
      leaveWeeks: parseFloat(dom.els.paidLeaveWeeks.value),

      disabilityPayout: parseFloat(dom.els.disabilityPayout.value),
      disabilityWeeks: parseFloat(dom.els.disabilityWeeks.value),

      ptoWeeks: parseFloat(dom.els.ptoWeeks.value),

      statePayout: parseFloat(dom.els.statePayout.value),
      stateWeeks: parseFloat(dom.els.stateWeeks.value),

      unpaidWeeks: parseFloat(dom.els.unpaidWeeks.value)
    };

    let {
      weekStateForm,
      weekPtoForm,
      weekDisabiltyForm,
      weekMaternityForm,
      weekUnpaidForm
    } = dom.els;

    let paidLeave = {
      dollars: vars.rate * vars.leaveWeeks || 0,
      weeks: vars.leaveWeeks || 0 // vars.hoursPerWeekSlider
    };

    if (weekMaternityForm.style.display === 'none') {
      paidLeave.dollars = 0;
      paidLeave.weeks = 0;
    }

    // console.log(JSON.stringify(paidLeave));

    let disability = {
      dollars: vars.disabilityPayout * vars.disabilityWeeks || 0,
      weeks: vars.disabilityWeeks || 0
    };

    if (weekDisabiltyForm.style.display === 'none') {
      disability.dollars = 0;
      disability.weeks = 0;
    }

    let pto = {
      dollars: vars.rate * vars.ptoWeeks || 0,
      weeks: vars.ptoWeeks || 0
    };

    if (weekPtoForm.style.display === 'none') {
      pto.dollars = 0;
      pto.weeks = 0;
    }

    let state = {
      dollars: vars.statePayout * vars.stateWeeks || 0,
      weeks: vars.stateWeeks || 0
    };

    if (weekStateForm.style.display === 'none') {
      state.dollars = 0;
      state.weeks = 0;
    }

    let unpaid = {
      weeks: vars.unpaidWeeks || 0
    };

    if (weekUnpaidForm.style.display === 'none') {
      unpaid.weeks = 0;
    }

    let totalWeeks =
      pto.weeks +
      state.weeks +
      Math.max(paidLeave.weeks, disability.weeks) +
      unpaid.weeks;
    let details = {
      totalWeeks,
      totalDollars:
        pto.dollars + disability.dollars + paidLeave.dollars + state.dollars,
      usualPay: vars.rate * totalWeeks
    };

    details.avgPerWeek = details.totalDollars / details.totalWeeks;

    // @TODO `toFixed` accordingly
    let ret = {
      paidLeave,
      disability,
      pto,
      state,
      unpaid,
      details
    };

    pubSub.trigger('model:calcsReady', ret);

    return ret;

    // paidLeaveDollars.html('$' + (paidLeave.dollars).toFixed(2) + '<small>p/w<\/small>');
    // paidLeaveWeeks.html(paidLeave.weeks + ' weeks');
    // // console.log(paidLeave.dollars);
    // var disability = {
    //   dollars: payout.val() * disabilityWeeks.val(),
    //   weeks: disabilityWeeks.val()
    // };
    // shortTermDollars.html(
    //   '$' + disability.dollars.toFixed(2) + '<small>p/w</small>'
    // );
    // shortTermWeeks.html(disability.weeks + ' weeks');
    // var pto = {
    //   dollars: rate.val() * hours.val() * ptoWeeks.val(),
    //   weeks: parseFloat(ptoWeeks.val())
    // };
    // ptoTotalWeeks.html(pto.weeks + ' weeks');
    // ptoDollars.html('$' + pto.dollars.toFixed(2) + '<small>p/w</small>');
    //
    // var tweeks = pto.weeks + Math.max(paidLeave.weeks, disability.weeks);
    // totalWeeks.html(tweeks + 'weeks');
    // var totalAmt = pto.dollars + disability.dollars + paidLeave.dollars;
    //
    // totalDollars.html('$' + totalAmt.toFixed(2) + '<small>p/w</small>');
    //
    // var avg = totalAmt / tweeks;
    // avgWeekly.html('$' + avg.toFixed(2) + '<small>p/w</small>');
  }

  init() {
    // this.vars = {
    //   listPrice: 601,
    //   competitorListPrice: 610,
    //   discountPrice: 0,
    //   competitorListPrice: 610,
    //   competitorDiscountPrice: 0,
    //   unitsTreatment: 20,
    //   // second form
    //   costPerUnit: 9,
    //   competitorDiscount: 0
    // };
    // this.vars.effectivePrice = this.effectivePrice();
    // this.vars.cogTreatment = this.cogTreatment();
    // this.vars.competitorTreatmentCostPerUnit = this.competitorTreatmentCostPerUnit();
    //
    // pubSub.trigger('var:set', {
    //   name: 'discountPrice',
    //   val: this.vars.discountPrice
    // });
    //
    // pubSub.trigger('var:set', {
    //   name: 'competitorDiscountPrice',
    //   val: this.vars.competitorDiscountPrice
    // });
    //
    // pubSub.trigger('var:set', {
    //   name: 'costPerUnit',
    //   val: this.vars.costPerUnit
    // });
    //
    // pubSub.trigger('var:set', {
    //   name: 'competitorDiscount',
    //   val: this.vars.competitorDiscount
    // });
    //
    // this.discountPrice({
    //   name: 'discountPrice',
    //   val: this.vars.discountPrice
    // });
  }

  onVarChanged(e) {
    if (this[e.name] != null) {
      this[e.name](e);
    }
  }

  hoursPerWeek(e) {
    this.vars.hoursPerWeek = e.val;
  }
  //
  // vsMarginDollars() {
  //   let dollars = this.vars.totalCompetitorMargin - this.vars.totalMargin;
  //   return Math.round(dollars * 100) / 100; // clean up dollar amount
  // }
  //
  // vsMarginChange() {
  //   let percent =
  //     (this.vars.totalCompetitorMargin - this.vars.totalMargin) /
  //     this.vars.totalMargin;
  //   return Math.round(percent * 100);
  // }
  //
  // effectivePrice() {
  //   const val =
  //     this.vars.listPrice - this.vars.listPrice * p(this.vars.discountPrice);
  //   return val;
  // }
  //
  // effectiveCompetitorPrice() {
  //   const val =
  //     this.vars.competitorListPrice -
  //     this.vars.competitorListPrice * p(this.vars.competitorDiscountPrice);
  //   return val;
  // }
  //
  // cogTreatment() {
  //   return this.vars.unitsTreatment * p(this.effectivePrice());
  // }
  //
  // cogCompetitorTreatment() {
  //   return this.vars.unitsTreatment * p(this.effectiveCompetitorPrice());
  // }
  //
  // competitorTreatmentCostPerUnit() {
  //   return (
  //     this.vars.costPerUnit -
  //     this.vars.costPerUnit * p(this.vars.competitorDiscount)
  //   );
  // }
  //
  // updateTreatmentCost() {
  //   this.vars.competitorTreatmentCostPerUnit = this.competitorTreatmentCostPerUnit();
  //   pubSub.trigger('calc:competitorTreatmentCostPerUnit', {
  //     name: 'competitorTreatmentCostPerUnit',
  //     val: this.vars.competitorTreatmentCostPerUnit
  //   });
  //
  //   this.vars.totalTreatment = this.vars.costPerUnit * this.vars.unitsTreatment;
  //   pubSub.trigger('calc:totalTreatment', {
  //     name: 'totalTreatment',
  //     val: this.vars.totalTreatment
  //   });
  //
  //   this.vars.totalMargin = this.vars.totalTreatment - this.vars.cogTreatment;
  //   pubSub.trigger('calc:totalMargin', {
  //     name: 'totalMargin',
  //     val: this.vars.totalMargin
  //   });
  //
  //   this.vars.totalCompetitorTreatment =
  //     this.vars.competitorTreatmentCostPerUnit * this.vars.unitsTreatment;
  //   pubSub.trigger('calc:totalCompetitorTreatment', {
  //     name: 'totalCompetitorTreatment',
  //     val: this.vars.totalCompetitorTreatment
  //   });
  //
  //   this.vars.totalCompetitorMargin =
  //     this.vars.totalCompetitorTreatment - this.vars.cogCompetitorTreatment;
  //
  //   pubSub.trigger('calc:totalCompetitorMargin', {
  //     name: 'totalCompetitorMargin',
  //     val: this.vars.totalCompetitorMargin
  //   });
  //
  //   this.vars.vsMarginChange = this.vsMarginChange();
  //   pubSub.trigger('calc:vsMarginChange', {
  //     name: 'vsMarginChange',
  //     val: this.vars.vsMarginChange
  //   });
  //
  //   this.vars.vsMarginDollars = this.vsMarginDollars();
  //   pubSub.trigger('calc:vsMarginDollars', {
  //     name: 'vsMarginDollars',
  //     val: this.vars.vsMarginDollars
  //   });
  // }
  // competitorDiscount(e) {
  //   this.vars.competitorDiscount = e.val;
  //   this.updateTreatmentCost();
  // }
  //
  // costPerUnit(e) {
  //   this.vars.costPerUnit = e.val;
  //   this.updateTreatmentCost();
  // }
  //
  // competitorDiscountPrice(e) {
  //   this.vars.competitorDiscountPrice = e.val;
  //
  //   // competitor calculated price
  //   this.vars.cogCompetitorTreatment = this.cogCompetitorTreatment();
  //
  //   pubSub.trigger('calc:calcedCompetitorPrice', {
  //     name: 'calcedCompetitorPrice',
  //     val: this.vars.cogCompetitorTreatment
  //   });
  //
  //   this.updateTreatmentCost();
  // }
  //
  // discountPrice(e) {
  //   this.vars.discountPrice = e.val;
  //
  //   // update allegran calculated price (COG Treatment)
  //   this.vars.cogTreatment = this.cogTreatment();
  //   pubSub.trigger('calc:calcedPrice', {
  //     name: 'calcedPrice',
  //     val: this.vars.cogTreatment
  //   });
  //
  //   this.updateTreatmentCost();
  // }
}

export default CalcModel;
